
import { defineComponent } from 'vue';
import ItemComment from '../items/ItemComment.vue';
import AppMessageInput from '@/components/UI/AppMessageInput.vue';

export default defineComponent({
  props: {
    popUp: { type: Boolean, default: false },
  },
  components: {
    ItemComment,
    AppMessageInput,
  },
  setup() {
    function sendMessage(message: string) {
      // console.log('send msg');
    }

    return {
      sendMessage,
    };
  },
});
